<template>
  <!-- <horizontal-stepper
    ref="stepper"
    class="vh-100"
    :steps="steps"
    :top-buttons="true"
    @completed-step="completeStep"
    @active-step="isStepActive"
    @stepper-finished="activate"
  ></horizontal-stepper>-->
  <!-- <tenant-details></tenant-details> -->
  <div class="w-100">
    <!-- <form ref="form" v-kendo-validator="!readOnly" novalidate> -->
    <div class="page-header d-flex w-100">
      <div class="title-col d-flex w-50">
        <span class="title-icon">
          <span class="nt-people-fill"></span>
        </span>
        <span class="title-text">New Tenant</span>
      </div>
      <!-- <div class="text-right ml-auto" v-if="!readOnly">
          <button class="k-button k-primary ml-2" type="button" @click="save">Save</button>
      </div>-->
      <!-- <div class="text-right ml-auto">
          <buttongroup>
            <k-button :togglable="true">
                Basic Tenant
            </k-button>
            <k-button :togglable="true">
                Advanced Tenant
            </k-button>
          </buttongroup >
      </div>-->
      
      <div class="text-right ml-auto">
        <div class="btn-group btn-toolbar" >
          <kendo-buttongroup :index="getTabIndex()" :style="{ width:'100%' }" class="rounded-border">
            <button type="button" class="btn btn-default rounded-border" :disabled="isTabDisabled" @click="onClickTabTenants(false)" >Basic Tenant</button>
            <button type="button" class="btn btn-default rounded-border" @click="onClickTabTenants(true)" >Advanced Tenant </button>
          </kendo-buttongroup>   
        </div>
      </div>
    </div>
    <div class="page-body">
      <tabstrip :selected="selected" @select="onSelect" >
        <tabstripTab :title="'Tenant Details'" >
          <div class="overflow-hidden">
            <tenant-detail-form ref="tenantDetailRef"></tenant-detail-form>
          </div>
        </tabstripTab>
        <tabstripTab :title="'User & Role'">
          <div class="overflow-hidden" style="width: 100% !important;">
            <add-users ref="userRoleRef"></add-users>
          </div>
        </tabstripTab>
        <tabstripTab :title="'Products, Packages & Add Ons'">
          <div>
            <product-selection ref="productRef"></product-selection>
          </div>
        </tabstripTab>
        <tabstripTab v-if="isAdvanced" :title="'Assign Database'">
          <div class="overflow-hidden">
            <database-config :tenantData = "tenantDetailData"></database-config>
          </div>
        </tabstripTab>
        <!-- <ul>
          <li class="k-state-active">Tenant Details</li>
          <li>Products, Packages & Add Ons</li>
          <li>User & Role</li>
          <li v-show="isAdvanced">Assign Database</li>
        </ul> -->
        <!-- <div class="overflow-hidden">
            <tenant-detail-form></tenant-detail-form>
          </div>
        <div class>
          <product-selection></product-selection>
        </div>
        <div class>
          <add-users></add-users>
        </div>
        <div class>
          <database-config></database-config>
        </div> -->
      </tabstrip>
      <!-- <div class> -->
      <!-- <div class="row"> -->
      <!-- <div class="col-sm-4"> -->
      <!-- <div class="form-group">
                <label class="required-field">Name</label>
                <k-input
                  :name="'Tenant Name'"
                  class="w-100"
                  :required="true"
                  v-model="tenant.name"
                  :disabled="readOnly"
                />
      </div>-->
      <!-- </div> -->

      <!-- <div class="col-sm-4"> -->
      <!-- <div class="form-group">
                <label class="required-field">Tenant Contact</label>
                <k-input
                  :name="'Tenant Contact Person'"
                  class="w-100"
                  :required="true"
                  v-model="tenant.contactPerson"
                  :disabled="readOnly"
                />
      </div>-->
      <!-- </div> -->
      <!-- <div class="col-sm-4"> -->
      <!-- <div class="form-group">
                <label class="required-field">Tenant Contact No</label>
                <k-input
                  :name="'Tenant Contact No'"
                  class="w-100"
                  :required="true"
                  v-model="tenant.contactNo"
                  :disabled="readOnly"
                />
      </div>-->
      <!-- </div> -->
      <!-- <div class="col-sm-4"> -->
      <!-- <div class="form-group">
                <label class="required-field">Tenant Contact Email</label>
                <k-input
                  :name="'Contact Email'"
                  class="w-100"
                  type="email"
                  :required="true"
                  v-model="tenant.emailId"
                  :disabled="readOnly"
                />
      </div>-->
      <!-- </div> -->
      <!-- <div class="col-sm-4"> -->
      <!-- <div class="form-group">
                <label class="required-field">Sub Domain Name</label>
                <k-input
                  :name="'Sub Domain Name '"
                  class="w-100"
                  :required="true"
                  v-model="tenant.subDomainName"
                  :disabled="readOnly"
                />
      </div>-->
      <!-- </div> -->
      <!-- <div class="col-sm-4"> -->
      <!-- <div class="form-group">
                <label>Website</label>
                <k-input
                  :name="'Website'"
                  class="w-100"
                  :required="true"
                  v-model="tenant.website"
                  :disabled="readOnly"
                />
      </div>-->
      <!-- </div> -->
      <!-- <div class="col-sm-4"> -->
      <!-- <div class="form-group d-flex">
                <label>Use Shared DB</label>
                <b-form-checkbox
                  v-model="tenant.useSharedDb"
                  class="ml-2"
                  :disabled="readOnly"
                  @change="resetDB"
                ></b-form-checkbox>
      </div>-->
      <!-- </div> -->
      <!-- </div> -->
      <!-- </div> -->
      <!-- <div class="buttons">
          <button type="button" class="btn btn-primary">Save</button>
          <button type="button" class="btn btn-info">Save & Activate</button>
          <button type="button" class="btn btn-default">Cancel</button>
      </div>-->
  <!-- <button type="button" class="save-button btn btn-primary ml-3 rounded-border" @click="onNext" >Save</button> -->
      <!-- <div class="text-right">
        <button type="button" class="save-button btn btn-primary ml-3 rounded-border" @click="save" >Save</button>
        <button type="button" style="color: #0047b2;" class="save-button btn ml-3 rounded-border">Save & Activate</button>
        <button type="button" style="margin-right: 10px;" class="save-button btn btn-default ml-3">Cancel</button> -->
        <!-- <button type="button" class="main-button btn btn-info" @click="activate">Save & Activate</button>
        <button type="button" class="main-button btn btn-default">Cancel</button> -->
      <!-- </div> -->

      
    </div>
    <div class="text-right" v-if="showButton">
      <button type="button" class="save-button btn btn-primary ml-3 rounded-border" @click="save" >Save</button>
      <button type="button" style="color: #0047b2;" class="save-button btn ml-3 rounded-border" v-if="isActivateEnable" @click="activate">Save & Activate</button>
      <button type="button" style="margin-right: 10px;" class="save-button btn btn-default ml-3 rounded-border" @click="close">Cancel</button>
    </div>
    <div class="text-right" v-if="!showButton">
      <button type="button" class="save-button btn btn-primary ml-3 rounded-border" v-if="selected !== 0" @click="previous" >Previous</button>
      <button type="button" style="margin-right: 10px;" class="save-button btn btn-default ml-3 rounded-border" @click="next">Save & Next</button>
      <button type="button" style="margin-right: 10px;" class="save-button btn btn-default ml-3 rounded-border" @click="close">Cancel</button>
    </div>
    <!-- </form> -->
  </div>
</template>

<script>
// import HorizontalStepper from "vue-stepper";
// import TenantDetails from "./TenantDetails";
import TenantDetailForm from "./TenantDetailForm";
import AddUsers from "./AddUsers";
import AddOnSelection from "./AddOnSelection";
import ProductSelection from "./ProductSelection";
import DatabaseConfig from "./DatabaseConfig";
import ConfigureSaas from "./SaasConfiguration";
import TenantPreview from "./TenantPreview";
// import AddVendors from "./TenantVendors";
import { createNamespacedHelpers } from "vuex";
import { notifyApiError, notify, notifyError } from "../../utils/notification-helper";
import MESSAGES from "@/utils/messages"
const { mapState, mapMutations, mapActions } = createNamespacedHelpers(
  "onboarding"
);
// import $ from "jquery"
import { TabStrip, TabStripTab } from '@progress/kendo-vue-layout';

export default {
  data: function() {
    return {
      steps: [
        // {
        //   icon: "account_box",
        //   name: "tenantDetailForm",
        //   component: TenantDetails,
        //   action: "addTenant",
        //   completed: false
        // },
        {
          icon: "people",
          name: "addUsers",
          component: AddUsers,
          completed: false
        },
        {
          icon: "apps",
          name: "productSelection",
          component: ProductSelection,
          completed: false
        },
        {
          icon: "library_add",
          name: "addons",
          component: AddOnSelection,
          completed: false
        },
        // {
        //   icon: "directions_car",
        //   name: "vendors",
        //   component: AddVendors,
        //   completed: false
        // },
        {
          icon: "settings_applications  ",
          name: "configureSaas",
          component: ConfigureSaas,
          completed: false
        },
        {
          icon: "cloud",
          name: "databaseConfig",
          component: DatabaseConfig,
          completed: false
        },
        {
          icon: "done",
          name: "preview",
          component: TenantPreview,
          completed: false
        }
      ],
      isAdvanced: false,
      selected: 0,
      isTabDisabled: false,
    };
  },
  components: {
    // HorizontalStepper
    // TenantDetails
    ProductSelection,
    AddUsers,
    // AddOnSelection,
    DatabaseConfig,
    TenantDetailForm,
    tabstrip: TabStrip,
    tabstripTab: TabStripTab,
  },
  computed: {
    ...mapState(["tenant", "tenantName", "tenantContact", "tenantDescription", "editField"]),
    draftTenant() {
      return this.tenant.id == 0;
    },
    showButton() {
      if(this.isAdvanced == false && this.selected == 2) {
        return true;
      } else if(this.isAdvanced == true && this.selected == 3) {
        return true;
      } else {
        return false;
      }
    },
    isActivateEnable() {
      if(this.editField == false) {
        return true;
      } else {
        if(this.tenant.activated == true) {
          return false;
        } else {
          return true;
        }
      }
    },
    tenantDetailData() {
      return this.$refs.tenantDetailRef;
    }
  },
  methods: {
    ...mapMutations(["addUser", "removeUser", "setConnectionString","clientIdEvent"]),
    ...mapActions([
      "addTenant",
      "saveUsers",
      "saveProduct",
      "saveDatabase",
      "saveSaasConfig",
      "loadSaasConfig",
      "createProfileConfig",
      "resetState",
      "activateTenant", 
      "activateTenantDtls",
      
    ]),
    activate() {
      if(this.isAdvanced) {
        this.tenant.subscription= "Advanced";
      } else {
        this.tenant.subscription= "Basic";
      }
      if((this.selected == 2 || this.selected == 3) && (this.$refs.tenantDetailRef.kendoValidator.validate() == false ||
      (this.$refs.userRoleRef.tenantData && this.$refs.userRoleRef.tenantData.length==0) ||
      (this.$refs.productRef.tableData && this.$refs.productRef.tableData.length==0))) {
        notifyError(MESSAGES.TENANT_SAVE_ERROR);
        return;
      } else {
      this.activateTenantDtls()
        .then(() => {
          notify(MESSAGES.TENANT_ACTIVATED);
          this.resetState();
          this.$store.dispatch("loadTenants", null, { root: true });
          this.$router.push("tenant-management");
        })
        .catch(notifyApiError);
      }
    },
    async completeStep() {},
    isStepActive(payload) {
      this.steps.forEach(step => {
        if (step.name === payload.name) {
          if (step.completed === true) {
            step.completed = false;
          }
        }
      });
    },
    onClickTabTenants(flag) {
      this.isAdvanced = flag;
      if(!flag && this.selected == 3) {
        this.selected = 0
      }
    },
    onSelect: function (e) {  
      this.selected = e.selected;
      if(this.selected == 3) {
        this.isTabDisabled = true;
      } else {
        this.isTabDisabled = false;
      }
    },
    onNext(){
      if(!this.isAdvanced && this.selected < 2){
        this.selected = this.selected + 1;
      } else if (this.isAdvanced && this.selected < 3) {
        this.selected = this.selected + 1;
      }    
      else {
        this.close()
      }
    },
    save: function() {
      if(this.isAdvanced) {
        this.tenant.subscription= "Advanced";
      } else {
        this.tenant.subscription= "Basic";
      }
      if((this.selected == 2 || this.selected == 3) && (this.$refs.tenantDetailRef.kendoValidator.validate() == false ||
      (this.$refs.userRoleRef.tenantData && this.$refs.userRoleRef.tenantData.length==0) ||
      (this.$refs.productRef.tableData && this.$refs.productRef.tableData.length==0))) {
        notifyError(MESSAGES.TENANT_SAVE_ERROR);
        return;
      } else {
        this.addTenant()
          .then(message => {
            notify(message);
            this.canContinue();
            this.onNext();
          })
          .catch(notifyApiError);
        }
    },
    previous() {
      this.selected = this.selected - 1;
    },
    next() {
      if(this.selected == 0 && this.$refs.tenantDetailRef.kendoValidator.validate() == false) {
        notifyError(MESSAGES.TENANT_DETAILS_ERROR);
        return;
      } else if(this.selected == 1 && this.$refs.userRoleRef.tenantData && this.$refs.userRoleRef.tenantData.length==0) {
        if(this.$refs.userRoleRef.kendoValidator.validate() == false) {
          notifyError(MESSAGES.USER_ROLE_ERROR);
        } else {
          notifyError(MESSAGES.USER_ROLE_ERROR);
        }
        return;
      } else if(this.selected == 2 && this.isAdvanced == true && this.$refs.productRef.tableData && this.$refs.productRef.tableData.length==0) {
        if(this.$refs.productRef.kendoValidator.validate() == false) {
          notifyError(MESSAGES.PRODUCT_SELECTION_ERROR);
        } else {
          notifyError(MESSAGES.PRODUCT_SELECTION_ERROR);
        }
        return;
      } else {
        this.selected = this.selected + 1;
      }
    },
    canContinue() {
      this.$emit("can-continue", { value: true });
    },
    close() {
      this.$store.dispatch("loadTenants").then(() => {
      this.$router.push("tenant-management");
      });
    },
    getTenantData() {
      return this.$refs.tenantDetailRef;
    },
    getTabIndex() {
      let index = 0;
      // if(this.editField == true) {
      //   if(this.tenant.subscription == "Basic") {
      //     this.isAdvanced = false;
      //     return index;
      //   } else {
      //     this.isAdvanced = true;
      //   return 1;
      //   }
      // } else {
        return index;
      }
    // }
  },
  mounted: function() {
    this.loadSaasConfig();
  }
};
</script>

<style>
.stepper-box .content {
  max-height: 50%;
  min-height: 50%;
  overflow-y: scroll !important;
}

.k-tabstrip-top > .k-tabstrip-items {
  border-bottom: 1px solid #ddd;
  border-top: none;
}

td,
th {
  text-align: center;
}

.main-button{
  width: 150px;
  margin-top: 10px;
}

.k-button-group .k-button:active, .k-button-group .k-button.k-state-active, .k-button-group .k-button.k-state-selected, .k-button-group > input[type=radio]:checked + .k-button, .k-button-group > input[type=checkbox]:checked + .k-button {
    border-color: #0047b2;
    color: #fff;
    background-color: #0047b2;
    border-radius: 5px;
    box-shadow: inset 0 2px 2px 0 rgb(0 0 0 / 6%);
}
.k-tabstrip-items {
    border-color: #0047b2 !important;
    border-bottom: 1px solid;
}
.k-tabstrip-items .k-item.k-state-active, .k-tabstrip-items .k-item.k-state-selected {
    border-color: rgba(33, 37, 41, 0.125);
    color: #0047b2;
    background-color: #dfe4ed;
    border-bottom: 2px solid;
}

.page-header {
    margin-top: 2px;
}
.k-animation-container {
  width: 100%;
}
</style>
